import { useLocation } from "react-router-dom";

import { SidebarNav } from "@/components/layout/SidebarNav";
import { adminScopeForPath, getNavForUser } from "@/components/layout/nav-config";
import { useAuth } from "@/contexts/auth-context";

// Desktop sidebar (280px). Hidden at/below the tablet breakpoint (≤1120px), where
// the same nav is presented through the mobile drawer instead. Nav-only — the brand
// lockup lives solely in the TopBar (latest UX screens), so it is not repeated here.
export function Sidebar() {
  const { user, isLegacyGated } = useAuth();
  const { pathname } = useLocation();
  // Story 15.7 — the super_admin nav is SCOPED, and the scope is derived from the
  // path rather than held in state, so the sidebar can never offer one estate's
  // list while the page beside it shows the other's.
  const isSuperAdmin = user?.role === "super_admin";
  const scope = adminScopeForPath(pathname);
  // Story 16.2 — gated legacy clinicians get the locked nav set (Workspace/
  // Clients/Evaluations/Results non-interactive; Profile + Resources live).
  const items = getNavForUser(user?.role, isLegacyGated, scope);

  return (
    <aside
      aria-label="Sidebar"
      className="hidden w-[280px] shrink-0 flex-col gap-5 rounded-[var(--radius-xl)] border border-[color:var(--border-primary)] bg-[color:var(--bg-secondary)] p-4 min-[1121px]:flex"
    >
      <SidebarNav
        items={items}
        adminScope={isSuperAdmin ? scope : undefined}
        pathname={pathname}
      />
    </aside>
  );
}
